import styled from "styled-components";
import * as colors from "src/styles/constants/colors";

export const EditButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  &:hover {
    background: ${colors.grey0};
  }
`;

export const Image = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 4px;
  margin-right: 8px;
`;
